var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('Button',{attrs:{"type":_vm.type,"disabled":_vm.disabled,"loading":_vm.loading,"icon":_vm.icon,"size":_vm.size},on:{"click":_vm.handleClick}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }